class Time {
  /**
   *
   * @param {number} timestamp - Provide in millisconds
   */
  static fromNow(timestamp: number) {
    if (typeof timestamp !== "number") return "NaN"

    const SECOND = 1000
    const MINUTE = 1000 * 60
    const HOUR = 1000 * 60 * 60
    const DAY = 1000 * 60 * 60 * 24
    const MONTH = 1000 * 60 * 60 * 24 * 30
    const YEAR = 1000 * 60 * 60 * 24 * 30 * 12

    const elapsed = new Date().valueOf() - timestamp

    if (elapsed <= MINUTE) return `${Math.round(elapsed / SECOND)} seconds ago`
    if (elapsed <= HOUR) return `${Math.round(elapsed / MINUTE)} minutes ago`
    if (elapsed <= DAY) return `${Math.round(elapsed / HOUR)} hours ago`
    if (elapsed <= MONTH) return `${Math.round(elapsed / DAY)} days ago`
    if (elapsed <= YEAR) return `${Math.round(elapsed / MONTH)} months ago`
    return `${Math.round(elapsed / YEAR)} years ago`
  }
  static pause(seconds = 3): Promise<Boolean> {
    return new Promise((res, rej) => {
      window.setTimeout(() => res(true), seconds * 1000)
    })
  }
  static onPause(seconds = 3, fn: () => void): number {
    return window.setTimeout(() => fn(), seconds * 1000)
  }
  /**
   * Robustly converts various timestamp formats to milliseconds.
   * Handles Firestore Timestamp, Date, and plain objects (serialized Dexie data).
   */
  static toMillis(ts: any): number {
    if (!ts) return 0
    if (typeof ts === "number") return Math.floor(ts)
    if (ts instanceof Date) return ts.getTime()
    if (typeof ts.toMillis === "function") return ts.toMillis()
    if (typeof ts.seconds === "number") {
      // Use Math.floor to ignore nanosecond remainders that cause sync conflicts
      return Math.floor(ts.seconds * 1000 + (ts.nanoseconds || 0) / 1000000)
    }
    if (typeof ts.getTime === "function") return ts.getTime()
    const date = new Date(ts)
    return isNaN(date.getTime()) ? 0 : date.getTime()
  }
}
export default Time
